<template>
  <div>
    <form @submit.prevent>
      <div class="row mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">Nazwa kategorii bazowej</div>
          </div>
          <input
            v-model="baseCategoryName"
            type="text"
            :class="baseCategoryNameClass"
            placeholder="Wpisz nazwę kategorii bazowej"
            aria-describedby="base-category-name-feedback"
          />
          <div class="invalid-feedback" id="base-category-name-feedback">
            Nazwa kategorii bazowej jest wymagana.
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">Typ drzewa</div>
          </div>
          <select v-model="categoryTreeType" :class="categoryTreeTypeClass">
            <option :value="null" disabled>Wybierz typ</option>
            <option v-for="opt in categoryTreeTypes" :key="opt.key" :value="opt.key">{{ opt.value }}</option>
          </select>
          <div class="invalid-feedback">
            Wybór typu drzewa jest wymagany.
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="assign-orphans" v-model="assignOrphans" />
          <label class="form-check-label" for="assign-orphans">Przypisz osierocone kategorie do bazowej</label>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default defineComponent({
  name: 'CategoryTreeForm',
  emits: ['onSave'],
  data() {
    return {
      baseCategoryName: '',
      categoryTreeType: null,
      assignOrphans: false,
      baseCategoryNameClass: 'form-control',
      categoryTreeTypeClass: 'form-control',
      categoryTreeTypes: [
        { key: 'ASSORTMENT_GROUP', value: 'Grupy asortymentowe' },
        { key: 'OWN_REPLACEMENT', value: 'Zamienniki własne' },
        { key: 'OTHER', value: 'Inny' },
      ],
    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    onApplyData() {
      return this.saveData();
    },
  },
  methods: {

    checkForm() {
      let notValid = 0;
      if (!this.baseCategoryName || this.baseCategoryName.trim().length === 0) {
        this.baseCategoryNameClass = 'form-control is-invalid';
        notValid++;
      } else {
        this.baseCategoryNameClass = 'form-control';
      }
      if (!this.categoryTreeType) {
        this.categoryTreeTypeClass = 'form-control is-invalid';
        notValid++;
      } else {
        this.categoryTreeTypeClass = 'form-control';
      }
      return notValid === 0;
    },
    saveData() {
      if (!this.checkForm()) {
        return null;
      }
      const payload = {
        baseCategoryName: this.baseCategoryName.trim(),
        categoryTreeType: this.categoryTreeType,
        assignOrphans: this.assignOrphans,
        // preferredIdentifier: 'ID',will be filled later, based on columns mapping
      };
      this.$emit('onSave', payload);
      return { form: payload };
    },
  },
});
</script>

<style scoped>
</style>
